import { encrypt } from '../helpers/Helpers';

export default async function ModifyInitialPassword({crewCode, password}) {
    // Encriptar la contraseña antes de enviar
    const encryptedPassword = encrypt(password, process.env.REACT_APP_KEY);

    const url = "https://gops.azulhandling.com/LoginPage/procesos_seguros/ChangeInitialPassword.php";
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': localStorage.getItem('token') || ''
        },
        body: JSON.stringify({
            crewCode,
            password: encryptedPassword
        }),
    })
    
    if(res.status == 200){
        return await res.json()
    }else{
        return "Error obteniendo los datos"
    }

}